module.exports = __webpack_public_path__ + "static/neon-b4b4eccb9323450d86e3d27d0639bfbf.png";